/*
 * cart-color-swap.js
 * Combined-listing cart colour switcher. Each colour is a separate product, so
 * "changing colour" = swap the line item: add the chosen colour's same-size
 * variant (with the current quantity), then remove the old line. Then re-render
 * the cart page / drawer / cart bubble via the Section Rendering API.
 *
 * Works with snippets/cart-color-selector.liquid (the <select data-cart-color-select>).
 * Uses event delegation on document, so it survives cart re-renders.
 */
(function () {
  if (window.__cartColorSwapInit) return;
  window.__cartColorSwapInit = true;

  function base() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }
  function addUrl() {
    return (window.routes && window.routes.cart_add_url) || '/cart/add';
  }
  function changeUrl() {
    return (window.routes && window.routes.cart_change_url) || '/cart/change';
  }

  function sectionFetch(id) {
    return fetch(`${base()}?section_id=${id}`).then((r) => r.text());
  }

  function replaceInner(html, sourceSelector, targetEl) {
    if (!targetEl) return;
    const src = new DOMParser().parseFromString(html, 'text/html').querySelector(sourceSelector);
    if (src) targetEl.innerHTML = src.innerHTML;
  }

  function refreshCartUI() {
    const tasks = [];
    const cartItems = document.querySelector('cart-items');
    const drawerItems = document.querySelector('cart-drawer-items');

    // Cart PAGE
    if (cartItems) {
      const mainEl = document.getElementById('main-cart-items');
      const mainId = (mainEl && mainEl.dataset.id) || 'main-cart-items';
      tasks.push(
        sectionFetch(mainId).then((html) => replaceInner(html, '.js-contents', cartItems.querySelector('.js-contents')))
      );
      const footer = document.getElementById('main-cart-footer');
      if (footer) {
        tasks.push(
          sectionFetch(footer.dataset.id).then((html) =>
            replaceInner(html, '.js-contents', footer.querySelector('.js-contents'))
          )
        );
      }
    }

    // Cart DRAWER
    if (drawerItems) {
      tasks.push(
        sectionFetch('cart-drawer').then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          ['cart-drawer-items', '.cart-drawer__footer'].forEach((sel) => {
            const src = doc.querySelector(sel);
            const dst = document.querySelector(sel);
            if (src && dst) dst.replaceWith(src);
          });
        })
      );
    }

    // Header cart bubble
    tasks.push(
      sectionFetch('cart-icon-bubble')
        .then((html) => {
          const src = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
          const dst = document.getElementById('cart-icon-bubble');
          if (src && dst) dst.innerHTML = src.innerHTML;
        })
        .catch(() => {})
    );

    return Promise.all(tasks);
  }

  function swap(select) {
    const newId = select.value;
    const lineKey = select.getAttribute('data-line-key');
    const qty = parseInt(select.getAttribute('data-quantity'), 10) || 1;
    const currentId = select.getAttribute('data-current-variant');
    if (!newId || newId === currentId) return;

    const row = select.closest('.cart-item');
    if (row) row.classList.add('cart-item--swapping');
    select.disabled = true;

    const headers = { 'Content-Type': 'application/json', Accept: 'application/json' };

    fetch(addUrl(), {
      method: 'POST',
      headers,
      body: JSON.stringify({ items: [{ id: Number(newId), quantity: qty }] }),
    })
      .then((r) => r.json())
      .then((added) => {
        if (added && added.status && added.status !== 200) {
          throw new Error(added.description || added.message || 'add failed');
        }
        // remove the old line (by its line key)
        return fetch(changeUrl(), {
          method: 'POST',
          headers,
          body: JSON.stringify({ id: lineKey, quantity: 0 }),
        });
      })
      .then((r) => r.json())
      .then(() => refreshCartUI())
      .catch((err) => {
        console.error('[cart-color-swap]', err);
        select.disabled = false;
        if (row) row.classList.remove('cart-item--swapping');
      });
  }

  document.addEventListener('change', function (e) {
    const t = e.target;
    const select = t && t.closest ? t.closest('[data-cart-color-select]') : null;
    if (select) swap(select);
  });
})();
